module.exports = __webpack_public_path__ + "static/img/logo-uncatering.1051fa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-uncatering.png
// module id = zqhu
// module chunks = 20